module.exports = __webpack_public_path__ + "front/img/content1.1c4fcdce.png";